export const AI_EDIT_PRESETS = [
    {
        id: "translate",
        label: "번역",
        prompt: "선택 영역을 문서 맥락에 맞게 자연스럽게 번역해줘. 선택 영역을 대체할 텍스트만 출력하고, LaTeX 문법은 유지해줘.",
    },
    {
        id: "rewrite",
        label: "다시쓰기",
        prompt: "선택 영역을 같은 의미를 유지하면서 더 자연스럽고 명확한 학술 문체로 다시 써줘. 선택 영역을 대체할 텍스트만 출력하고, LaTeX 문법은 유지해줘.",
    },
];

export function getAIEditPresetPrompt(presetId) {
    return AI_EDIT_PRESETS.find((preset) => preset.id === presetId)?.prompt || "";
}
